import { NOTIFICATION_PROMPT } from 'js/store/notification/notification.actions';

const initState = {
  active: false,
  type: false,
  data: {},
  queue: [],
};

const notification = (state = initState, action) => {
  let nextState = {};
  switch (action.type) {
    case NOTIFICATION_PROMPT: {
      if (state.active && action.payload.type) {
        nextState.queue = [...state.queue, action.payload];
        return { ...state, ...nextState };
      }

      if (state.active && !action.payload.type && state.queue.length > 0) {
        const nextPrompt = state.queue[0];
        nextState.type = nextPrompt.type;
        nextState.data = nextPrompt;
        nextState.queue = state.queue.slice(1);
        return { ...state, ...nextState };
      }

      if (state.active && !action.payload.type && state.queue.length === 0) {
        nextState.active = false;
        nextState.type = false;
        nextState.data = false;
        return { ...state, ...nextState };
      }

      nextState.active = true;
      nextState.type = action.payload.type;
      nextState.data = action.payload;
      return { ...state, ...nextState };
    }
  }
  return state;
};

export default notification;
